// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"31e39adf","513":"06e81cf6","703":"3fd777b3"}[chunkId] + ".chunk.js";
};